module.exports = __webpack_public_path__ + "static/media/studyHeaderIcon.a076c1f3.svg";